import { Component, OnDestroy, OnInit } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Subject } from "rxjs";
import {
  decryptResponse,
  encryptRequest,
  isEmailValid,
} from "src/app/core/constants/constants";
import { PaymentService } from "src/app/pages/shared/services/payment.service";

@Component({
    selector: "app-recurring-details",
    templateUrl: "./recurring-details.component.html",
    styleUrls: ["./recurring-details.component.scss"],
    standalone: false
})
export class RecurringDetailsComponent implements OnInit, OnDestroy {
  clientId: string;
  clientRef: string;

  planDetailsForm: UntypedFormGroup;
  destroy$ = new Subject<void>();

  decryptedValue: any;
  errorMessage: string;

  showModal: boolean;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private fb: UntypedFormBuilder,
    private paymentService: PaymentService
  ) {}

  ngOnInit() {
    this.planDetailsForm = this.fb.group({
      firstName: ["", Validators.required],
      lastName: ["", Validators.required],
      subscriberEmail: ["", Validators.required],
      phoneNumber: ["", Validators.required],
      address: ["", Validators.required],
    });
    this.route.params.subscribe((param) => {
      this.clientId = param.clientId;
      // this.clientRef = param.ref;
    });

    this.route.queryParams.subscribe((param) => {
      this.decryptedValue = decryptResponse(param.q);
    });
  }

  moveToPayment() {
    const payload = this.planDetailsForm.value;
    payload.clientId = this.clientId;
    payload.planReference = this.decryptedValue.reference;
    payload.email = payload.subscriberEmail;
    payload.planName = this.decryptedValue.name ?? this.decryptedValue.planName;
    payload.amount = this.decryptedValue.amount;
    // needed for next payment amount for instalments
    payload["maxNumberOfPayments"] = this.decryptedValue["maxNumberOfPayments"];

    if (!isEmailValid(payload.email)) {
      this.errorMessage = "Email is invalid";
      this.showModal = true;
      return;
    }

    const { firstName, lastName, ...req } = payload;
    const isInstalment = this.route.snapshot.queryParamMap.get("isInstalment");
    this.router.navigate(["payments", this.clientId], {
      queryParams: {
        q: encryptRequest(payload),
        ...(!!isInstalment &&
          isInstalment === "true" && {
            isInstalment: true,
          }),
      },
    });
  }

  onlyNumbers(event: KeyboardEvent) {
    if (
      event.code == "Delete" ||
      event.code == "Backspace" ||
      event.code == "Tab" ||
      event.code == "Escape" ||
      event.code == "Enter" ||
      // Allow: Ctrl+A
      (event.code == "KeyA" && event.ctrlKey === true)
      // Allow: home, end, left, right
      // || (event.keyCode >= 35 && event.keyCode <= 39)
    ) {
      // let it happen, don't do anything
      return;
    } else {
      // Ensure that it is a number and stop the keypress
      if (event.shiftKey || !this.isNumberKey(event.code)) {
        event.preventDefault();
      }
    }
  }

  isNumberKey(keyboardEventCode: string): boolean {
    const numbersKeyCodes = [
      "Digit1",
      "Digit2",
      "Digit3",
      "Digit4",
      "Digit5",
      "Digit6",
      "Digit7",
      "Digit8",
      "Digit9",
      "Digit0",
    ];
    return numbersKeyCodes.includes(keyboardEventCode);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
